<i class="object-icon {{icon}} {{iconClass}}"></i>
